import { MouseEvent } from 'react'
import { getLink } from '@helpers/env'
import { analytics } from '@helpers/analytics'
import { getIsFirstTimeUser } from '@helpers/session/user'
import Link from '@components/ui/Link'
import { MixAndMatchProduct } from '..'
import styles from './styles.module.scss'

function Card({
  product,
  eventAction
}: {
  product: MixAndMatchProduct
  eventAction: 'Product Card 1' | 'Product Card 2'
}) {
  const handleCardClick = (ev: MouseEvent<HTMLAnchorElement>) => {
    ev.preventDefault()
    const firstTimeUser = getIsFirstTimeUser()
    analytics('Click', {
      category: 'Landing Page',
      label: 'Mix-Match',
      action: eventAction,
      type: firstTimeUser ? 'new' : 'existing'
    })
    window.open(ev.currentTarget.href, '_blank')
  }
  return (
    <div className={styles.productCards__Card}>
      <a
        href={getLink(product.handle)}
        target="_blank"
        onClick={handleCardClick}
      >
        <img src={product?.thumbnail} alt={product?.title} />
      </a>
      <h5 className={styles.productCards__Title}>{product?.title}</h5>
      <Link href={product.handle} target="_blank" onClick={handleCardClick}>
        Shop now
      </Link>
    </div>
  )
}

type ProductCardsProps = {
  products: {
    tops: MixAndMatchProduct[]
    bottoms: MixAndMatchProduct[]
  }
  activeCategory: {
    tops: number
    bottoms: number
  }
}

export default function ProductCards({
  products,
  activeCategory
}: ProductCardsProps) {
  const topsSelectedProduct = products?.tops.find(
    product => product.id === activeCategory.tops
  )
  const bottomsSelectedProduct = products?.bottoms.find(
    product => product.id === activeCategory.bottoms
  )

  return (
    <div className={styles.productCards}>
      {topsSelectedProduct && (
        <Card product={topsSelectedProduct} eventAction="Product Card 1" />
      )}
      {bottomsSelectedProduct && (
        <Card product={bottomsSelectedProduct} eventAction="Product Card 2" />
      )}
    </div>
  )
}
